type RowObj = {
	name: string;
	status: string;
	date: string;
	progress: number;
};

const tableDataComplex: RowObj[] = [
	{
		name: 'Cesar Alvarez',
		progress: 75.5,
		status: 'Aprobado',
		date: '12 Ene 2021'
	},
	{
		name: 'Diana mendez',
		progress: 25.5,
		status: 'No disponible',
		date: '21 Feb 2021'
	},
	{
		name: 'Mario Diaz',
		progress: 90,
		status: 'Error',
		date: '13 Mar 2021'
	},
	{
		name: 'Camila Perez',
		progress: 50.5,
		status: 'Aprobado',
		date: '24 Oct 2022'
	}
];
export default tableDataComplex;
